import {WRONG_EMAIL_NOTIFICATION, WRONG_NAME_NOTIFICATION} from 'consts/wordings';
import {
  getEmailErrorMessage,
  getEmptyFieldErrorMessage,
  getProperNameErrorMessage,
  getUserNameErrorMessage,
} from 'utils/validators';
import { AccountInfoData, FormNotifications, CurrentUser } from 'types';

export const getAccountInfoStep = (
  user: CurrentUser,
  notifications: Record<string, FormNotifications>,
  onPass: (newUser: AccountInfoData | CurrentUser, id: string) => void,
  setNotifications: (notif: Record<any, FormNotifications>) => null,
) => ({
  stepName: 'Account Info',
  onPass: async (data: AccountInfoData) => {
    if (!data.photo){
      setNotifications({
        signUpStep2: {
          mode: 'error',
          header: 'The photo is required',
        },
      });
      return
    }
    onPass(data, 'signUpStep2');
  },
  formProps: {
    buttonCaption: 'Continue',
    notifications: notifications,
    fields: [
      {
        type: 'notification',
        fieldName: 'signUpStep2',
      },
      {
        type: 'title',
        fieldName: 'title',
        value: 'Time to get SENDY!',
      },
      {
        type: 'description',
        fieldName: 'value',
        value: '',
      },
      {
        type: 'image',
        fieldName: 'photo',
        buttonCaption: 'Upload Photo',
        header: 'Add a profile photo*',
        description: 'We want you to feel seen, please consider using a real picture \nImage needs to be less than 5MB',
        value: user.photo,
      },
      {
        type: 'template',
        gridColumns: 'grid_1_1',
        fields: [
          {
            type: 'text',
            fieldName: 'first_name',
            placeholder: 'First Name *',
            value: user?.first_name,
            required: true,
            validator: getProperNameErrorMessage,
          },
          {
            type: 'text',
            fieldName: 'last_name',
            placeholder: 'Last Name *',
            value: user?.last_name,
            required: true,
            validator: getProperNameErrorMessage,
          },
        ],
      },
      !user.email ? {
        type: 'text',
        fieldName: 'email',
        placeholder: 'Email *',
        value: user?.email,
        required: true,
        errorMessage: WRONG_EMAIL_NOTIFICATION,
        validator: getEmailErrorMessage,
      } : {},
      user.account_type==='business' ? {
        type: 'text',
        fieldName: 'business_name',
        placeholder: 'Business Name *',
        value: user?.business_name,
        required: true,
        validator: getEmptyFieldErrorMessage,
      } : {},
      {
        type: 'text',
        fieldName: 'username',
        placeholder: 'User Name *',
        value: user?.username,
        required: true,
        errorMessage: WRONG_NAME_NOTIFICATION,
        validator: getUserNameErrorMessage,
      },
    ],
  },
});
